import Vue from 'vue'
import './style.css'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 动画 animate.css
import "animate.css";
import store from './store';
import VerifyCode from '@/utils/Verifcation.js'
import Num_TO_Percentage from '@/utils/Num_TO_Percentage'
Vue.filter('Num_TO_Percentage',Num_TO_Percentage)
Vue.prototype.$VerifyCode = VerifyCode.install
Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.directive('has', {
  inserted(Ele, binding, vNode) {
    const value = binding.value
    const rightsBTN = localStorage.getItem('BTN_RIGHTS') || ''
    console.log(value, rightsBTN);
    if (value !== rightsBTN && Ele.parentNode) {
      Ele.parentNode.removeChild(Ele)
    }
  }
})
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')


